const routes = [
    {
        path: "/years",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "year_index"
        }
    }
];

export default routes;
